<template>
  <div>
    <headd :mobile_title="mobile_title"></headd>

    <div class="city container">
      <div class="locate">当前城市：{{ city }}</div>
      <div class="hot">
        <div class="hot_title">热门城市</div>
        <div class="hot_list">
          <div
            class="hl_item"
            v-for="item in hotcity"
            @click="selectCity($event)"
            :data-title="item.title"
            :key="item.title"
          >
            {{ item.title }}
          </div>
        </div>
      </div>

      <div class="all">
        <!-- <view class="all_title">更多城市</view> -->
        <div class="all_item" v-for="(item, key) in allcity" :key="key">
          <div class="all_item_province">{{ key }}</div>
          <div class="all_item_list">
            <div
              class="ail_item"
              v-for="item_1 in item"
              @click="selectCity($event)"
              :data-title="item_1.title"
              :key="item_1.title"
            >
              {{ item_1.title }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <foot></foot>
  </div>
</template>

<script>
import { getallcity } from "../api/api"; //引入api里面定义的方法
import headd from "@/components/head";
import foot from "@/components/foot";
export default {
  data() {
    return {
      mobile_title: "城市选择",
      hotcity: [],
      allcity: [],
      city: localStorage.getItem("city")
      //cityflag: uni.getStorageSync("cityflag")
    };
  },
  metaInfo: {
    title: "马上创业网 专注企业注册的网站", // set a title
    meta: [
      {
        // set meta
        name: "keyWords",
        content:
          "马上创业网，注册公司，代理记账，上海注册公司，注册公司流程，注册公司费用，商标注册，法务咨询，法律服务，个体工商户注册，许可证办理，专业法律，社保，公积金，专利申请，医疗器械许可证，ICP电信增值许可证，食品经营许可证，酒类经营许可证，餐饮服务许可证，道路运输许可证，广播电视节目许可证，海关资质，进出口许可证，商标设计，logo设计，VI设计，海报设计，包装设计，APP开发，微信运营，网站定制，版权服务，软件著作权，发明专利，外观设计专利，实用新型专利，商标转让，驳回复审，注销公司，股权变更，经营范围变更，股权协议，股权转让，劳务派遣"
      },
      {
        name: "description",
        content:
          "马上创业网是一个专为中小企业服务的综合平台，主要提供医疗器械服务、审计服务、知识产权服务、财税咨询、注册公司、代理记账、商标注册、专利申请、社保代理、法务代理等一站式的服务，借助移动互联网技术，改善并升级企业服务状态，实现了新形势下中小企业所需要的企业服务。"
      }
    ]
  },
  components: {
    headd,
    foot
  },
  metaInfo: {
    title: "城市-马上创业网 专注企业注册的网站", // set a title
    meta: [
      {
        // set meta
        name: "keyWords",
        content:
          "上海公司注册,杭州公司注册,成都公司注册,北京公司注册,沈阳公司注册,宁波公司注册,注册公司,公司注册,代办公司注册,注册公司费用及流程,代理注册公司,代理注册,马上创业网提供上海公司注册,版权登记,软件著作权,注册公司,公司注册,代办公司注册,注册公司费用及流程,代理注册公司,代理注册等服务,马上创业网,专注公司注册的网站,提供一站式的公司注册服务,劳务派遣,个人社保,企业社保,创业法律服务"
      },
      {
        name: "description",
        content:
          "马上创业网，专注公司注册的网站，提供一站式的公司注册服务，劳务派遣，个人社保,企业社保,创业法律服务"
      }
    ]
  },
  mounted() {
    this.allcitylist();
  },
  methods: {
    async allcitylist() {
      var _self = this;
      const res = await getallcity();

      _self.hotcity = res.data.data.hot;
      _self.allcity = res.data.data.allcity;
    },
    selectCity(e) {
      //console.log(e.target.dataset.title);
      var citytitle = e.target.dataset.title;
      //uni.setStorageSync("city", citytitle);
      localStorage.setItem("city", citytitle);
      this.$router.push({
        path: "/"
      });
    }
  },
  onShow() {
    this.allcitylist();
  }
};
</script>

<style lang="less" scoped>
page {
  background-color: #f2f2f2;
}

.city {
  flex-direction: column;
  width: 8rem;
  margin: 0.32rem auto;
  @media (max-width: 991px) {
    width: 6.86rem;
  }

  .locate {
    padding-left: 0rem;
    background-color: #fff;
    line-height: 0.33rem;
    text-align: left;
    justify-content: flex-start;
    font-size: 0.2rem;
    @media (max-width: 991px) {
      font-size: 0.28rem;
      line-height: 0.42rem;
    }
  }

  .hot {
    flex-direction: column;

    .hot_title {
      margin: 0.24rem 0;
      font-size: 0.24rem;
      font-weight: bolder;
      text-align: left;
      @media (max-width: 991px) {
        font-size: 0.28rem;
        line-height: 0.42rem;
      }
    }

    .hot_list {
      justify-content: flex-start;
      flex-wrap: wrap;
      background-color: #ffffff;
      display: flex;
      text-align: left;

      .hl_item {
        font-size: 0.18rem;
        line-height: 0.25rem;
        text-align: left;
        align-items: center;
        justify-content: center;
        width: 20%;
        cursor: pointer;
        @media (max-width: 991px) {
          font-size: 0.28rem;
          line-height: 0.33rem;
        }
        //border-top: 0.01rem solid #ededed;
        //border-bottom: 0.01rem solid #ededed;
        //border-left: 0.01rem solid #ededed;
      }
    }
  }

  .all {
    width: 100%;
    flex-direction: column;

    .all_title {
      margin: 0.24rem 0;
      font-size: 0.24rem;
      @media (max-width: 991px) {
        font-size: 0.28rem;
        line-height: 0.42rem;
      }
    }

    .all_item {
      flex-direction: column;
      display: flex;
      text-align: left;
      .all_item_province {
        font-size: 0.2rem;
        padding: 0.2rem 0;
        font-weight: bolder;
        @media (max-width: 991px) {
          font-size: 0.28rem;
          line-height: 0.42rem;
        }
      }

      .all_item_list {
        justify-content: flex-start;
        flex-wrap: wrap;
        width: 100%;
        background-color: #ffffff;

        .ail_item {
          cursor: pointer;
          font-size: 0.18rem;
          line-height: 0.25rem;
          text-align: left;
          align-items: center;
          justify-content: center;
          width: 20%;
          margin-bottom: 0.1rem;
          @media (max-width: 991px) {
            font-size: 0.28rem;
            line-height: 0.42rem;
            width: auto;
            margin-right: 0.3rem;
          }
          //   border-bottom: 0.01rem solid #ededed;
          //   border-right: 0.01rem solid #ededed;
          display: inline-block;

          &:nth-child(3n) {
            border-right: none;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/city/index.vue